import sliceCreator from '../../index.jsx';
import {CREATE_REGION} from '../../../constants/index.jsx';
const _createRegionAction = sliceCreator('CREATE_REGION', CREATE_REGION, 'post');

const { asyncAction: createRegionAction, reducer, clearData: clearCreateRegionAction } = _createRegionAction;

export default reducer;

export {
    createRegionAction,
    clearCreateRegionAction
}